/**
 * Date-extensions locale Kazakh [kk]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('kk', {
    monthNames: ['қаңтар','ақпан','наурыз','сәуір','мамыр','маусым','шілде','тамыз','қыркүйек','қазан','қараша','желтоқсан'],
    monthShortNames: ['қаң','ақп','нау','сәу','мам','мау','шіл','там','қыр','қаз','қар','жел'],
    dayNames: ['жексенбі','дүйсенбі','сейсенбі','сәрсенбі','бейсенбі','жұма','сенбі'],
    dayShortNames: ['жек','дүй','сей','сәр','бей','жұм','сен']
});
